/*
 * 프로젝트에서 사용되는 정규식을 관리하는 파일입니다.
 * 필요한 정규식을 import 하여 사용하시면 됩니다.
 */

/* HTML 엔터티 문자를 제거하는 정규식 */
export const REMOVE_ENTITY_HTML = /&\w+;/g;

/* HTML 태그가 존재할 시 태그 제거 후 텍스트만 꺼내주는 정규식 */
export const STRIPED_HTML = /<[^>]+>.*?/g;

/* HTML 태그가 존재할 시 태그 제거 후 텍스트만 꺼내주는 정규식 (공백 허용 <br>) */
export const STRIPED_HTML_BUT_HAS_BLANK = /<(?!br)[^>]+>.*?/g;

export const STRIPED_HTML_EXCEPT_MENTION =
  /<(?!div|br|span.+class="mention"|\/span)[^>]+>.*?/g;

/* BR 태그찾기 */
export const FIND_BR = /<br[^>]+>/g;

/* A 태그찾기 */
export const FIND_A = /<a[^>]+>.*?<\/a>/g;

/* 이미지 태그만 찾기  */
export const FIND_IMG_TAG = /<img[^>]+>/g;

/* URL 패턴 찾기  */
export const FIND_URL_PATTERN =
  /(http?|https?):\/\/([a-z0-9-]+\.)+[a-z0-9]{2,4}.*$/g;

/* 스타일 제거 */
export const REMOVE_STYLE = /(class|style|title|id|name)=("|').*?("|')/g;

export const REMOVE_ONLY_STYLE = /style=".*?"/g;

/* 1. 일반, 갤러리 게시판에서 업로드된 파일의 태그를 찾는 정규식, 속성 중에 data-type이 반드시 uploaded로 지정되어 있어야 한다. */
export const FIND_UPLOADED_IMG =
  /<img[^>]*data-type=["']uploaded?['"]([^>"']+)["']?[^>]*>/g;

/* 2. 일반, 갤러리 게시판에서 업로드된 파일의 태그를 찾는 정규식, 
속성 중에 data-type이 반드시 uploaded로 지정되어 있거나 src 속성에 위하고 s3 서버의 호스트가 명시되어 있어야 한다. */
export const FIND_UPLOADED_IMG_EXPANED =
  /(<img[^>]*src=["']http:\/\/dev\.api0\.wehago\.com\/?([^>"']+)["']?[^>]*>)|(<img[^>]*src=["']https:\/\/api0\.wehago\.com\/?([^>"']+)["']?[^>]*>)|(<img[^>]*data-type=["']uploaded?([^>"']+)["']?[^>]*>)/g;

/* 3. 비인증 API를 타고 있는 URL만 추출  ("", '' 사이에 있는 경우)*/
export const FIND_NO_AUTH_API =
  /(http:\/\/dev\.api0\.wehago\.com\/.*?(?=["']))|(https:\/\/api0\.wehago\.com\/.*?(?=["']))/g;

/* 3. 비인증 API를 타고 있는 URL만 추출  (끝나는 지점 상관없이 해당 호스트가 포함되어 있으면 체크)*/
export const FIND_NO_AUTH_API_SIMPLE =
  /(http:\/\/dev\.api0\.wehago\.com\/.*?)|(https:\/\/api0\.wehago\.com\/.*?)/i;

/* 4. s3 URL만 추출  (끝나는 지점 상관없이 해당 호스트가 포함되어 있으면 체크)*/
export const FIND_S3_URL = /(https:\/\/s1\.wehago\.com\/.*?)/i;

/* 3. IMG TAG에서 src만 추출  */
export const EXTRACT_SRC_IMGNODE = /src=(["'].*?["'])/g;

/* 3-1. IMG TAG에서 src 하나만 추출, 0번쨰 인덱스가 src를 포함한 문자열, 1번쨰 인덱스가 src안에 들어가는 주소  */
export const EXTRACT_SRC_IMGNODE_SINGLE = /src=["'](.*?)(?=["'])/i;

/* 4. 모든 공백 추출  */
export const FIND_SPACE = /\s/g;

/* DATA URI 찾기, global 옵션 제외시 하위표현식으로 캡쳐된 uri 조각들을 각각 추출할 수 있다.  */
export const FIND_DATA_URI =
  /\s*data:([a-z]+\/[a-z0-9\-\+]+(;[a-z\-]+\=[a-z0-9\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

//export const FIND_DATA_URI_WITH_SRC = /src="|')data:(((?:\w+\/(?:(?!;).)+)?)((?:;[\w\W]*?[^;])*),(.+))("|')$/g;

export const CAPTURE_DATA_URI_TYPE = /data:image\/.*?(.*?);/i;

/* 멘션 추출 (@로 시작해서 공백 문자로 끝나는것들 )  */
//export const FIND_MENTION = /@.*?(?=\s|<div>|<\/div>|<br>|$)/i;

/* 멘션 추출 (커서 맨마지막에서 공백 뒤의 @까지 탐색)  */
export const FIND_MENTION_ONE = /@{1}([a-z가-힣\d]+)(?=$)/i;

export const URL_SCHEME = /(http?|https?):\/\//;

export const YOUTUBE_EMBED = /www.youtube.com\/embed/;

export const REGEX_NUMBER = /[^0-9]/g;

// 최소 하나의 문자(대소문자 구분 X), 숫자, 특수문자를 포함하는 8 ~ 16자리의 글자
// export const REGEX_PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()+|\-=):'{}[\]",<>\?])[A-Za-z\d~!@#$%^&*()+|\-=):'{}[\]",<>\?]{8,128}$/;
export const REGEX_PASSWORD =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{12,128}$/;

// 문자 + 숫자 조합 8 ~ 16자리의 글자
export const REGEX_ID = /^(?=.*[A-Za-z])(?=.*\d)[a-zA-Z0-9]{8,50}$/;

// export const REGEX_INPUT = /[^0-9a-zA-Z$%()\-_=+\[\]{}:\'",.\/?\s]/g;
export const REGEX_INPUT = '';

// export const REGEX_INPUT = /[^0-9a-zA-Z,()_\s]/g;
export const REGEX_INPUT_NOT_SPEIAL_CHAR = /[^0-9a-zA-Z,\s]/g;

// export const REGEX_INPUT_MASS = /[^0-9a-zA-Z$%()\-_=+\[\]{}:\'",.\/?\s]/;
export const REGEX_INPUT_MASS = '';

export const REGEX_EMAIL =
  /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;

export const REGEX_PRICE = /[^0-9.]/g;
